module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-card-wrapper",
    class: {
      'segment-card': _vm.isSegmentCard
    },
    on: {
      "click": _vm.toggleSegment
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSegmentCard && _vm.paramsClient.nb_screen_segment !== 1),
      expression: "isSegmentCard && paramsClient.nb_screen_segment !== 1"
    }],
    staticClass: "number-screen"
  }, [_vm._v("\n    " + _vm._s(_vm.nuberScreen) + "\n  ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isSegmentCard || _vm.paramsClient.nb_screen_segment === 1),
      expression: "!isSegmentCard || paramsClient.nb_screen_segment === 1"
    }],
    staticClass: "time-screen"
  }, [_vm._v("\n    " + _vm._s(_vm._f("FormatTime")(_vm.duration)) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "parent",
    class: [{
      selected: _vm.isSelected
    }, _vm.typecard]
  }, [_c('div', {
    staticClass: "folder small blue",
    class: _vm.typecard
  }, [_c('div', {
    staticClass: "thumb_page tile",
    class: {
      segment: _vm.segment,
      'module-list': _vm.isModuleList,
    }
  }, [_c('div', {
    staticClass: "slide tile__media",
    class: [{
      'module-list': _vm.isModuleList
    }]
  }, [_c('div', {
    ref: "cardEl",
    staticClass: "containerScreen tile__img",
    class: [{
      'module-list': _vm.isModuleList,
      screen: !_vm.isSegmentCard
    }],
    style: ({
      backgroundImage: _vm.backgroundImage
    }),
    on: {
      "click": function($event) {
        return _vm.$emit('selected')
      }
    }
  }, [(!_vm.isModuleList) ? _c('ul', {
    staticClass: "actions-wrapper",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.checkTarget($event)
      }
    }
  }, [_c('v-popover', {
    staticClass: "more-actions-btn-parent",
    attrs: {
      "offset": "16",
      "container": "#editor",
      "popoverClass": "card-tooltip",
      "placement": "top",
      "default-placement": "top"
    }
  }, [_c('li', {
    staticClass: "fa fa-ellipsis-v item-li li-edit more-actions-btn open-menu-style",
    attrs: {
      "title": _vm.$t('panels.editScreen')
    }
  }), _vm._v(" "), _c('template', {
    slot: "popover"
  }, [_c('custom-panel-card-actions', {
    attrs: {
      "index": _vm.index,
      "is-segment-card": _vm.isSegmentCard,
      "card": _vm.slide,
      "segment": _vm.segment
    },
    on: {
      "selected": function($event) {
        return _vm.$emit('selected')
      },
      "duplicated": function($event) {
        return _vm.$emit('duplicated')
      }
    }
  })], 1)], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.paramsClient.nb_screen_segment !== 1) ? _c('div', {
    staticClass: "place-title"
  }, [_vm._v("\n              " + _vm._s(_vm.slide.title) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.paramsClient.nb_screen_segment === 1 && _vm.slide.screens) ? _c('div', {
    staticClass: "place-title"
  }, [_vm._v("\n              " + _vm._s(_vm.slide.screens[0].title) + "\n            ")]) : _vm._e()])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2df76069","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Panel/CustomPanelCard.vue
// module id = 823
// module chunks = 1 3